import MActionBar from './MActionBar.vue';

MActionBar.install = (app) => {
  app.component('MActionBar', MActionBar);
};

export { MActionBar };
